/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router components
import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftButton from "components/SoftComponents/SoftButton";
import SoftAvatar from "components/SoftComponents/SoftAvatar";
import SoftBadge from "components/SoftComponents/SoftBadge";

// Custom styles for DeviceSelectionCard
// import style from "template/examples/Cards/DeviceSelectionCard/style";

function DeviceSelectionCard({ title, description, locations, action, value = {} }) {
  // const classes = style();

  return (
    <Card
      sx={{ boxShadow: "0rem 0.625rem 0.75rem 0.05rem rgba(0, 0, 0, 0.2);" }}
    >
      <SoftBox pt={2} pb={2} px={2}>
        <SoftBox
          sx={{
            position: 'absolute',
            right: '12px',
            top: '12px'
          }}
        >
        </SoftBox>
        <SoftBox height="45px">
          <SoftTypography variant="h6" lineHeight={1.3}>{title}</SoftTypography>
        </SoftBox>
        <SoftBox mt={1} mb={2} lineHeight={0}>
          {typeof description == "string" ? (
            <SoftTypography variant="button" fontWeight="regular" color="text">
              {description}
            </SoftTypography>
          ) : (
            <SoftBox display="flex" flexDirection="column">
              {description.map((desc, index) => (
                <SoftTypography key={index} variant="button" fontWeight="regular" color="text">
                  {desc}
                </SoftTypography>
              ))}
            </SoftBox>
          )}
        </SoftBox>
        <SoftBox
          bgColor="grey-100"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          borderRadius="lg"
          p={1}
        >
          {value?.amount ? (
            <SoftTypography variant="h5" verticalAlign="text-bottom">
              {value?.method ? (
                <SoftBox component="span" mr={0.5}>
                  <SoftTypography
                    variant="button"
                    color="secondary"
                    fontWeight="medium"
                    verticalAlign="text-bottom"
                  >
                    {value?.type}
                  </SoftTypography>
                </SoftBox>
              ) : null}
              {value?.amount}
              {value?.method ? (
                <SoftBox component="span" ml={0.5}>
                  <SoftTypography
                    variant="button"
                    color="secondary"
                    fontWeight="medium"
                  >
                    {value?.method}
                  </SoftTypography>
                </SoftBox>
              ) : null}
            </SoftTypography>
          ) : (
            <SoftBox />
          )}
          {action && (
            <>
              {action.type === "internal" ? (
                <SoftButton component={Link} to={action.route} variant="gradient" color="dark">
                  {action.label}
                </SoftButton>
              ) : (
                <SoftButton
                  // component="a"
                  // href={action.route}
                  // target="_blank"
                  // rel="noreferrer"
                  type={action.type}
                  onClick={action.onClick}
                  variant="gradient"
                  color="dark"
                  disabled={action.func}
                >
                  {action.label}
                </SoftButton>
              )}
            </>
          )}
        </SoftBox>
      </SoftBox>
    </Card >
  );
}

// Typechecking props for the DeviceSelectionCard
DeviceSelectionCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.array,
  locations: PropTypes.object,
  action: PropTypes.object,
  value: PropTypes.object,
};

export default DeviceSelectionCard;
